(function ($) {
    var sizeMediaMap = {
        xs: '(max-width:379px)',
        sm: '(min-width:380px) and (max-width:479px)',
        md: '(min-width:480px) and (max-width:719px)',
        lg: '(min-width:720px) and (max-width:1023px)',
        xl: '(min-width:1024px)'
    };

    init();

    function init() {
        if (window.WEP && window.WEP.isPageEditor()) {
            return;
        }
        fixBlankSrc();
        appendImgLinks();
        $.subscribe('xom.breakpoints', onBreakpointsChanged);
    }

    // functoion to replcae blank src with next /previous available src
    function fixBlankSrc() {
        $(".jsimage picture").each(function () {
            var sources = $(this).find("source");
            var srcArray = sources
                .map(function () {
                    return $(this).attr("srcset") || ""; // Collect all srcset attributes
                })
                .get();

            sources.each(function (index) {
                if (!srcArray[index]) {
                    // If the srcset is empty
                    // Look forward for the next non-empty srcset
                    var nextSrc = srcArray.slice(index + 1).find(function (src) {
                        return src !== "";
                    });
                    if (nextSrc) {
                        $(this).attr("srcset", nextSrc);
                    } else {
                        // If not found, look backward for the previous non-empty srcset
                        var prevSrc = srcArray
                            .slice(0, index)
                            .reverse()
                            .find(function (src) {
                                return src !== "";
                            });
                        if (prevSrc) {
                            $(this).attr("srcset", prevSrc);
                        }
                    }
                }
            });
        });
    }
    function onBreakpointsChanged() {
        // Check if there are any tabs on the page
        if ($(".tab-pane").length > 0) {
            // Handle images inside the active tab
            var activeTabImages = $('.tab-pane.active .breakpoints .component.jsimage img');
            activeTabImages.each(function () {
                var $this = $(this);
                setImageSrc($this);
                $this.addClass("lazy-loaded-image lazy");
            });
        }

        // Handle all images on the page
        var allImages = $('.breakpoints .component.jsimage img');
        allImages.each(function () {
            var $this = $(this);

            // If tabs exist, skip images in inactive tabs
            if ($(".tab-pane").length > 0) {
                var inTabPane = $this.closest('.tab-pane');
                if (inTabPane.length && !inTabPane.hasClass('active')) {
                    return; // Skip images in inactive tabs
                }
            }

            //skip for C03 carousel component images
            if ($this.closest('.c03-carousel').length > 0) {
                return;
            }

            // Process the image
            setImageSrc($this);
            $this.addClass("lazy-loaded-image lazy");
        });

        // Invoke lazy loading for images
        invokeLazyLoadImages();
    }

    function setImageSrc(img) {
        //return if the component has exclude list
        var component = img.parents(".row").first();
        if (component.hasClass("exclude-responsive")) {
            return;
        }

        var pictureSources = img.closest('.component').find('picture source').toArray();
        var parentSize = getBreakpointParent(img).data('breakpoint');
        var bestSrc = getBestImageSource(parentSize, pictureSources);
        var breakPointValue = getCurrentBreakpoint();
        pictureSources.forEach(function (source) {
            var mediaCheck = source.getAttribute('media');
            if (sizeMediaMap[breakPointValue] === mediaCheck && bestSrc != null &&
                source.getAttribute('srcset') != bestSrc.srcset) {
                source.setAttribute('srcset', bestSrc.srcset);
                source.setAttribute('height', bestSrc.height);
                source.setAttribute('width', bestSrc.width);
            }
        });

        if (bestSrc.srcset === img.attr('src') || bestSrc.srcset == null || bestSrc.srcset == "") {
            return;
        }

        //img.attr('src', '');
        //img.attr('data-src', bestSrc.srcset);
    }

    function getBreakpointParent(img) {
        var breakpointParent = img.data('breakpointParent');
        if (breakpointParent) return breakpointParent;
        breakpointParent = img.closest('.breakpoints');
        img.data('breakpointParent', breakpointParent);
        return breakpointParent;
    }

    function getBestImageSource(size, sources) {
        var result = null;
        sources.forEach(function (source) {
            var media = source.getAttribute('media');
            var srcset = source.getAttribute('srcset');
            var width = source.getAttribute('width');
            var height = source.getAttribute('height');
            if (media === sizeMediaMap[size] && srcset && !result) {
                result = { srcset: srcset, height: height, width: width };
            }
        });
        return result;
    }

    function getCurrentBreakpoint() {
        var width = window.innerWidth;
        if (width <= 379) return 'xs';
        if (width <= 479) return 'sm';
        if (width <= 719) return 'md';
        if (width <= 1023) return 'lg';
        return 'xl';
    }

    function appendImgLinks() {
        var $imageComponents = $('.component.image');
        $imageComponents.each(function (i, v) {
            var url = $(v).data('url');
            if (url && url !== '#' && $(v).find('a').length) {
                $(v).find('a').attr('href', url);
            }
        });
    }

    function invokeLazyLoadImages() {
        var lazyImages = [].slice.call(document.querySelectorAll(".lazy-loaded-image.lazy"));
        var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    var lazyImage = entry.target;

                    lazyImage.classList.remove("lazy");
                    lazyImageObserver.unobserve(lazyImage);
                    var ele = $(lazyImage).parents(".component.list");
                    if (ele.length > 0) {
                        $('.match-height').each(function () {
                            var selectors = $(this).attr('data-match-height-selectors') ? $(this).attr('data-match-height-selectors').split(',') : [];
                            selectors.forEach(function (selector) {
                                matchHeightlazy($(this).find(selector));
                            }, this);
                        });
                    }
                }
            });
        });
        lazyImages.forEach(function (lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    }

    function matchHeightlazy(children) {
        var height = 0;
        children.css('height', 'auto');
        children.each(function () {
            height = Math.max(height, getHeightLazy($(this)));
        });
        if (children.selector === '.surfaced-item-copy')
            children.css('height', height + 'px');
        else
            children.css('min-height', height + 'px');
    }

    function getHeightLazy(element) {
        return parseInt(element.css('height'));
    }
}(window.jQuery));